export enum Divers {
  RESERVE_BLOCK = 'reserve-block',
  EMPTY_SPACE = 'empty-space',
}
